<template>
  <time v-if="drawDate && timeZone" class="flex gap-200 text-capitalize" :datetime="drawDate">
    <IconWithCaption
      :caption="formatDate(drawDate, 'fullDate', timeZone, locale)"
      icon="calendar"
    />
    <LotteryDrawLabel v-if="timeOfDay" :label="timeOfDay" />
    <IconWithCaption :caption="formatDate(drawDate, 'drawingTime', timeZone, locale)" icon="time" />
  </time>
</template>

<script lang="ts" setup>
const { locale } = useI18n()
const { drawDate, timeOfDay, timeZone } = await useResultDetails()
</script>
